import BaseField from "./BaseField";

export class TagField extends BaseField {
    constructor(props) {
        super(props);
        this.state = {
            currentInput: '',
            matchingItems: null,
        }
        this.deleteItem = this.deleteItem.bind(this);
        this.searchItems = this.searchItems.bind(this);
        this.addItem = this.addItem.bind(this);
        this.selectItem = this.selectItem.bind(this);
        this.renderAutocomplete = this.renderAutocomplete.bind(this);
    }

    deleteItem(id){
        let itemToDelete = null;
        this.props.Items.forEach(item => {
            if(item.ID === id){
                itemToDelete = item;
                itemToDelete.Selected = false;
                itemToDelete.action = 'delete';
            }
        })
        if(itemToDelete !== null){
            this.props.collectData(this.props.id, itemToDelete);
        }
    }

    selectItem(id){
        let itemToSelect = null;
        this.props.Items.forEach(item => {
            if(item.ID === id){
                itemToSelect = item;
                itemToSelect.Selected = !item.Selected;
            }
        })
        if(itemToSelect !== null){
            this.props.collectData(this.props.id, itemToSelect);
        }
        this.setState({
            currentInput: '',
        })
    }

    addItem(){
        if(this.state.currentInput !== ''){
            let itemToAdd = null;
            this.props.Items.forEach(item => {
                if(item.Title === this.state.currentInput){
                    itemToAdd = item;
                }
            })
            if(itemToAdd === null){
                itemToAdd = {
                    'ID': Date.now(),
                    'action': 'add',
                    'dataType': 'item',
                    'Title': this.state.currentInput,
                    'Selected': true,
                }
            }
            this.props.collectData(this.props.id, itemToAdd);
            this.setState({
                currentInput: '',
            })
        }
    }

    searchItems(value){
        if(value !== ''){
            let foundItems = this.props.Items.filter((item) => {
                let title = item.Title.toLowerCase();
                return title.includes(value.toLowerCase());
            })
            this.setState({
                matchingItems: foundItems,
                currentInput: value
            })
        } else {
            this.setState({
                currentInput: ''
            })
        }
    }

    renderAutocomplete(){
        if(this.state.matchingItems === null || this.state.currentInput === ''){
            return null;
        }
        return this.state.matchingItems.map((item, index) => {
            if(!item.Selected){
                return (
                    <div className="mb-2 mb-md-3 d-inline-block me-3" key={index}>
                        <button type="button" className="matchingItem btn btn-primary font-14 add py-2 px-3" key={index} onClick={(e) => {this.selectItem(item.ID)}}>
                            {item.Title}
                        </button>
                    </div>
                )
            }
        })
    }

    renderSelectedSkills(){
        if(this.props.Items === undefined){
            return null;
        }
        return this.props.Items.map((item, index) => {
            if(item.Selected){
                return (
                    <div className="skill d-inline-block mb-1 mb-md-3 mb-lg-4" key={index}>
                        <span className="selected__skill">
                            {item.Title}
                        </span>
                        <button type="button" className="delete__icon"  onClick={(e) => {this.deleteItem(item.ID)}}/>
                    </div>
                )
            }
        })
    }

    renderField(){
        return(
            <div className="field tagfield">
                <label className="">
                    {this.renderLabelText()}
                </label>
                <div className="tagfield__holder position-relative mb-3 mb-md-4">
                    <input type="search" className="form-control" value={this.state.currentInput} placeholder={this.props.Placeholder} required={this.props.Required} onInput={(e) => {this.searchItems(e.target.value)}} />
                    <button type="button" className="add btn btn-primary" onClick={(e) => {this.addItem()}}>
                        {this.props.ButtonCaption}
                    </button>
                </div>
                {this.renderAutocomplete()}
            </div>
        )
    }

    render(){
        return(
            <div id={this.props.id} className={this.props.Columns}>
                {this.renderSelectedSkills()}
                {this.renderField()}
                {this.renderErrorMessage()}
            </div>
        )
    }

}

export default TagField;
